import { render, staticRenderFns } from "./CaseImageForm.vue?vue&type=template&id=15ca20b1&scoped=true&"
import script from "./CaseImageForm.vue?vue&type=script&lang=js&"
export * from "./CaseImageForm.vue?vue&type=script&lang=js&"
import style0 from "./CaseImageForm.vue?vue&type=style&index=0&id=15ca20b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca20b1",
  null
  
)

export default component.exports